// extracted by mini-css-extract-plugin
export default {"customAmountInput":"styles_customAmountInput__TLlOV"};